import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import ViewSpaceExternalCollaboratorsDialogQuery, {
	type ViewSpaceExternalCollaboratorsDialogQuery$data,
	type ViewSpaceExternalCollaboratorsDialogQuery$variables,
} from './__generated__/ViewSpaceExternalCollaboratorsDialogQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadSpaceGuestList(spaceKey: string): Promise<{
	data: ViewSpaceExternalCollaboratorsDialogQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<
		ViewSpaceExternalCollaboratorsDialogQuery$data,
		ViewSpaceExternalCollaboratorsDialogQuery$variables
	>({
		query: ViewSpaceExternalCollaboratorsDialogQuery,
		variables: {
			spaceKey,
		},
	});
}
